/**
 * buildFilterPayload
 * 
 * Prepara el payload de filtros para enviar al SP.
 * REGLA: si hay algún filtro activo que NO sea fecha (folio, proveedor,
 * globalSearch, etc.), las fechas se envían como null para NO limitar
 * la búsqueda por rango de fecha.
 * 
 * @param {object} filterData - Estado de filtros del componente
 * @param {string[]} dateFields - Nombres de los campos de fecha a ignorar condicionalmente
 * @returns {object} payload limpio con fechas nullificadas si aplica
 */
export function buildFilterPayload(filterData, dateFields = ['FECHA_INICIO', 'FECHA_FIN']) {
    if (!filterData) return filterData;

    // Campos que fuerzan la anulación de fechas (Búsqueda por ID único/Folio)
    const priorityFields = ['FOLIO', 'FOLIO_REQUI', 'ORDEN', 'REQUI'];

    const hasPriorityFilter = Object.entries(filterData).some(([key, val]) => {
        if (!priorityFields.includes(key)) return false;
        return val !== null && val !== undefined && String(val).trim() !== '';
    });

    if (!hasPriorityFilter) {
        // No hay búsqueda por Folio → Respetar el rango de fechas siempre
        return filterData;
    }

    // Se está buscando un Folio específico → Ignorar fechas para encontrar el registro
    const payload = { ...filterData };
    for (const field of dateFields) {
        payload[field] = null;
    }
    return payload;
}
